import React from 'react';
import { Message } from 'primereact/message';

const CompanyBanner = ({ companyName }) => {
    return (
        <Message
            severity="info"
            className="w-full justify-content-start"
            content={
                <div className="flex align-items-center gap-2">
                    <i className="pi pi-building"></i>
                    <span>You are registering under <strong>{companyName}</strong></span>
                </div>
            }
        />
    );
};

export default CompanyBanner;
